export enum GACategories {
  kpiInsights = "KPI insights"
}

export enum GAActions {
  closeInsight = "Close Insight",
  goToEnableInsight = "Go to Enable insight",
  goToSettings = "Go to Settings",
  hoverHelp = "Hover help",
  openInsight = "Open insight",
  selectPage = "Select page",
  startGamePlan = "Start game plan"
}
